// import { List, Box, ListItem, ListItemButton, ListItemIcon, ListItemText, Collapse, Tooltip, Divider, Typography, } from "@mui/material";
// import { NavLink, useLocation, useNavigate } from "react-router-dom";
// import { ChevronRight as ChevronRightIcon, ExpandMore as ExpandMoreIcon, Phone as PhoneIcon, Email as EmailIcon, } from "@mui/icons-material";
// import menuData from "./menuData";
// import { useState } from "react";

// const Menu = ({ drawerOpen, isMobile, user, showUnauthorized, saveRecent, menuDataOverride, onFlyoutRequest, closeMobileMenu, }) => {
//   const dataToUse = menuDataOverride || menuData;
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [openFields, setOpenFields] = useState({});

//   const isRegularUser = user?.UserCategory === "User";
//   const userDesignation = user?.Designation;
//   const userId = user?.UserId || user?.id;

//   const isNativeApp = typeof window !== "undefined" && window.isNativeApp;

//   const isSubActive = (subFields) => {
//     if (!subFields) return false;
//     return Object.values(subFields).some(
//       (sub) => location.pathname === sub.link,
//     );
//   };

//   const handleMenuClick = (key, hasSub, link, label, e) => {
//     if (key === "usermanagement" && isRegularUser) {
//       showUnauthorized();
//       return;
//     }
//     if (!hasSub && link) {
//       navigate(link);
//       saveRecent({ label, link });
//       if (isMobile && closeMobileMenu) {
//         closeMobileMenu();
//       }
//       return;
//     }
//     if (hasSub) {
//       e.preventDefault();
//       if (drawerOpen) {
//         setOpenFields((prev) => ({ [key]: !prev[key] }));
//       } else {
//         onFlyoutRequest?.(key, e.currentTarget);
//       }
//     }
//   };

//   const shouldShowMenuItem = (key) => {
//     const companyId = user?.CompId;
//     if (userDesignation === "Admin" && companyId === 62) {
//       return true;
//     }
//     if (userDesignation === "HR" && companyId === 62) {
//       return key === "HRmanagement";
//     }
//     if (companyId === 62 && key === "HRmanagement") {
//       return false;
//     }
//     if (key === "usermanagement" && isRegularUser) {
//       return false;
//     }
//     return true;
//   };

//   const shouldShowSubMenuItem = (parentKey, subKey) => {
//     if (userId === 87) return true;
//     if (parentKey === "Marketing" && subKey === "reassign2" && isRegularUser) {
//       return false;
//     }
//     return true;
//   };

//   return (
//     <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
//       <List sx={{ px: 1, pt: 1, pb: 0.5, flex: 1, overflowY: "auto" }}>
//         {Object.entries(dataToUse).map(([key, item]) => {
//           if (!shouldShowMenuItem(key)) return null;
//           const hasSub = !!item.subFields;
//           const activeParent = hasSub ? isSubActive(item.subFields) : location.pathname === item.link;
//           return (
//             <Box key={key} sx={{ mb: 0.3 }}>
//               <ListItem disablePadding>
//                 <Tooltip title={!drawerOpen ? item.label : ""} placement="right" arrow >
//                   <ListItemButton onClick={(e) => handleMenuClick(key, hasSub, item.link, item.label, e) } sx={{ minHeight: 44, borderRadius: 2, px: drawerOpen ? 2 : 1.8, py: 0.8, justifyContent: drawerOpen ? "initial" : "center", bgcolor: activeParent ? "primary.50" : "transparent", color: activeParent ? "primary.main" : "text.secondary", "&:hover": { bgcolor: activeParent ? "primary.100" : "action.hover", }, transition: "all 0.2s ease", position: "relative", overflow: "hidden", }} >
//                     {activeParent && (
//                       <Box sx={{ position: "absolute", left: 0, top: 0, bottom: 0, width: 4, bgcolor: "primary.main", borderTopRightRadius: 4, borderBottomRightRadius: 4, }} />
//                     )}
//                     <ListItemIcon sx={{ minWidth: 0, mr: drawerOpen ? 3 : "auto", justifyContent: "center", color: "inherit", fontSize: "1.25rem", }} >
//                       {item.icon}
//                     </ListItemIcon>
//                     {drawerOpen && (
//                       <ListItemText primary={item.label} primaryTypographyProps={{ fontSize: "0.875rem", fontWeight: activeParent ? 600 : 500, color: "inherit", noWrap: true, }} />
//                     )}
//                     {hasSub && drawerOpen && (
//                       <Box sx={{ ml: "auto", color: "inherit" }}>
//                         {openFields[key] ? (
//                           <ExpandMoreIcon fontSize="small" />
//                         ) : (
//                           <ChevronRightIcon fontSize="small" />
//                         )}
//                       </Box>
//                     )}
//                   </ListItemButton>
//                 </Tooltip>
//               </ListItem>
//               {hasSub && (drawerOpen || isMobile) && (
//                 <Collapse in={!!openFields[key]} timeout={300} unmountOnExit>
//                   <List component="div" disablePadding sx={{ pt: 0.3 }}>
//                     {Object.entries(item.subFields).map(([subKey, sub]) => {
//                       if (!shouldShowSubMenuItem(key, subKey)) return null;
//                       const isActive = location.pathname === sub.link;
//                       return (
//                         <ListItem key={subKey} disablePadding sx={{ mb: 0.2 }}>
//                           <ListItemButton component={NavLink} to={sub.link}
//                             onClick={() => {
//                               saveRecent({ label: sub.label, link: sub.link, });

//                               if (isMobile && closeMobileMenu) {
//                                 closeMobileMenu();
//                               }
//                             }}
//                             sx={{
//                               minHeight: 38,
//                               borderRadius: 1.5,
//                               px: drawerOpen ? 3.5 : 2.5,
//                               py: 0.5,
//                               ml: drawerOpen ? 4 : 2,
//                               bgcolor: isActive ? "primary.50" : "transparent",
//                               color: isActive ? "primary.main" : "text.secondary",
//                               "&:hover": { bgcolor: isActive ? "primary.100" : "action.hover", },
//                               transition: "all 0.2s ease",
//                               position: "relative",
//                             }}
//                           >
//                             {isActive && (
//                               <Box sx={{ position: "absolute", left: -10, top: "50%", transform: "translateY(-50%)", width: 6, height: 6, borderRadius: "50%", bgcolor: "primary.main", }} />
//                             )}
//                             <ListItemIcon sx={{ minWidth: 0, mr: 2.5, color: "inherit", fontSize: "1.1rem", }} >
//                               {sub.icon}
//                             </ListItemIcon>
//                             {(drawerOpen || isMobile) && (
//                               <ListItemText primary={sub.label} primaryTypographyProps={{ fontSize: "0.8125rem", fontWeight: isActive ? 600 : 500, color: "inherit", }} />
//                             )}
//                           </ListItemButton>
//                         </ListItem>
//                       );
//                     })}
//                   </List>
//                 </Collapse>
//               )}
//             </Box>
//           );
//         })}
//       </List>
//       <Box
//         sx={{ px: 1, pb: 2, borderTop: "1px solid", borderColor: "divider" }}
//       >
//         <Divider sx={{ my: 2 }} />
//         {drawerOpen && (
//           <Typography variant="caption" sx={{ display: "block", fontWeight: 600, color: "text.secondary", mb: 1.5, textTransform: "uppercase", fontSize: "0.7rem", letterSpacing: "0.5px", }} >
//             Support
//           </Typography>
//         )}
//         <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 2 }}>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//             <PhoneIcon sx={{ fontSize: "1.1rem", color: "text.secondary", flexShrink: 0, }} />
//             {drawerOpen && (
//               <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
//                 {isNativeApp ? (
//                   <Typography component="a" href="tel:8866015003" sx={{ fontSize: "0.83rem", color: "text.secondary", fontWeight: 500, }} >
//                     8866015003
//                   </Typography>
//                 ) : (
//                   <Typography sx={{ fontSize: "0.82rem", color: "text.secondary", fontWeight: 500, }} >
//                     8866015003
//                   </Typography>
//                 )}
//                 {isNativeApp ? (
//                   <Typography component="a" href="tel:8866015004" sx={{ fontSize: "0.83rem", color: "text.secondary", fontWeight: 500, }} >
//                     8866015004
//                   </Typography>
//                 ) : (
//                   <Typography sx={{ fontSize: "0.82rem",  color: "text.secondary", fontWeight: 500, }} >
//                     8866015004
//                   </Typography>
//                 )}
//                 {isNativeApp ? (
//                   <Typography component="a" href="tel:8866015005" sx={{ fontSize: "0.83rem", color: "text.secondary", fontWeight: 500, }} >
//                     8866015005
//                   </Typography>
//                 ) : (
//                   <Typography sx={{ fontSize: "0.82rem", color: "text.secondary", fontWeight: 500, }} >
//                     8866015005
//                   </Typography>
//                 )}
//               </Box>
//             )}
//           </Box>
//         </Box>

//         {drawerOpen && (
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//             <EmailIcon sx={{ fontSize: "1.1rem", color: "text.secondary", flexShrink: 0, }} />
//             <Typography variant="caption" component="a" href="mailto:connect.reonbook@gmail.com" sx={{ fontSize: "0.75rem", color: "text.secondary", fontWeight: 500, textDecoration: "none", "&:hover": { color: "primary.main" }, }} >
//               connect.reonbook@gmail.com
//             </Typography>
//           </Box>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default Menu;

import { List, Box, ListItem, ListItemButton, ListItemIcon, ListItemText, Collapse, Tooltip, Divider, Typography, alpha, } from "@mui/material";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ExpandMore as ExpandMoreIcon, Phone as PhoneIcon, Email as EmailIcon, LockOutlined as LockIcon, } from "@mui/icons-material";
// Static menuData default export is commented out (see menuData.jsx) — the
// app now runs on the dynamic tree, always passed in via menuDataOverride.
import { useState } from "react";

// ─── Facebook-oriented palette ────────────────────────────────────────────────
const FB = { primary: "#1877F2", primaryLight: "#E7F0FD", dark: "#0C5DC7", sidebar: "#ffffff", text: "#1c1e21", textSub: "#65676B", divider: "#E4E6EB", hover: "#F0F2F5", };

// Shared premium easing curve — a gentle "overshoot" spring feel without being bouncy.
const EASE = "cubic-bezier(0.34, 1.15, 0.64, 1)";

// ─── Active left-bar indicator ────────────────────────────────────────────────
// Always mounted (never conditionally rendered) so switching modules animates
// the bar growing from the center with a soft spring, rather than popping in/out.
function ActiveBar({ active }) {
    return (
        <Box
            sx={{
                position: "absolute", left: 2, top: "50%", width: 3.5, height: active ? "62%" : "0%",
                bgcolor: FB.primary, borderRadius: 4,
                opacity: active ? 1 : 0,
                transform: "translateY(-50%)",
                transformOrigin: "center",
                transition: `height 0.32s ${EASE}, opacity 0.22s ease`,
                boxShadow: active ? `0 0 8px ${alpha(FB.primary, 0.45)}` : "none",
                pointerEvents: "none",
            }}
        />
    );
}

// ─── Active dot for sub-items ─────────────────────────────────────────────────
// Same approach as ActiveBar — always mounted, animated with a soft spring pop.
function ActiveDot({ active }) {
    return (
        <Box
            sx={{
                position: "absolute", left: -8, top: "50%", width: 6, height: 6, borderRadius: "50%",
                bgcolor: FB.primary,
                opacity: active ? 1 : 0,
                transform: active ? "translateY(-50%) scale(1)" : "translateY(-50%) scale(0)",
                transition: `transform 0.32s ${EASE}, opacity 0.22s ease`,
                boxShadow: active ? `0 0 6px ${alpha(FB.primary, 0.5)}` : "none",
                pointerEvents: "none",
            }}
        />
    );
}

// ─── Reusable contact row ─────────────────────────────────────────────────────
function ContactRow({ href, text, isNativeApp }) {
    const sx = { fontSize: "0.8rem", color: FB.textSub, fontWeight: 500, lineHeight: 1.9, display: "block", textDecoration: "none", "&:hover": { color: FB.primary }, };
    return isNativeApp ? (
        <Typography component="a" href={href} sx={sx}>
            {text}
        </Typography>
    ) : (
        <Typography sx={{ ...sx, cursor: "default" }}>{text}</Typography>
    );
}

// ─── Main Menu ────────────────────────────────────────────────────────────────
const Menu = ({ drawerOpen, isMobile, user, showUnauthorized, saveRecent, menuDataOverride, onFlyoutRequest, closeMobileMenu, canAccess, showAccessDenied, rightsLoading, rightsReady, appVersion, }) => {
    const dataToUse = menuDataOverride || {};
    const location = useLocation();
    const navigate = useNavigate();
    const [openFields, setOpenFields] = useState({});

    const isRegularUser = user?.UserCategory === "User";
    const userDesignation = user?.Designation;
    const userId = user?.UserId || user?.id;
    const isNativeApp = typeof window !== "undefined" && window.isNativeApp;

    const isSubActive = (subFields) => subFields ? Object.values(subFields).some((s) => location.pathname === s.link) : false;

    const handleMenuClick = (key, hasSub, link, label, e) => {
        if (label === "User Management" && isRegularUser) {
            showUnauthorized();
            return;
        }
        if (!hasSub && link) {
            navigate(link);
            saveRecent({ label, link });
            if (isMobile && closeMobileMenu) closeMobileMenu();
            return;
        }
        if (hasSub) {
            e.preventDefault();
            if (drawerOpen) {
                setOpenFields((prev) => ({ [key]: !prev[key] }));
            } else {
                onFlyoutRequest?.(key, e.currentTarget);
            }
        }
    };

    const shouldShowMenuItem = (key, label) => {
        const cid = user?.CompId;
        if (userDesignation === "Admin" && cid === 62) return true;
        if (userDesignation === "HR" && cid === 62) return key === "HRmanagement";
        if (cid === 62 && key === "HRmanagement") return false;
        if (label === "User Management" && isRegularUser) return false;
        return true;
    };

    const shouldShowSubMenuItem = (parentKey, subKey) => {
        if (userId === 87) return true;
        if (parentKey === "Marketing" && subKey === "reassign2" && isRegularUser)
            return false;
        return true;
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%", bgcolor: FB.sidebar, }} >
            {/* ── Nav list ─────────────────────────────────────────────────────── */}
            <List sx={{ px: 1, pt: 1.5, pb: 0.5, flex: 1, overflowY: "auto", "&::-webkit-scrollbar": { width: 4 }, "&::-webkit-scrollbar-track": { bgcolor: "transparent" }, "&::-webkit-scrollbar-thumb": { bgcolor: alpha(FB.primary, 0.22), borderRadius: 4, }, "&::-webkit-scrollbar-thumb:hover": { bgcolor: alpha(FB.primary, 0.42), }, }} >
                {Object.entries(dataToUse).map(([key, item]) => {
                    if (!shouldShowMenuItem(key, item.label)) return null;

                    const hasSub = !!item.subFields;
                    const activeParent = hasSub ? isSubActive(item.subFields) : location.pathname === item.link;
                    const isExpanded = !!openFields[key];

                    return (
                        <Box key={key} sx={{ mb: 0.5 }}>
                            {/* Parent row */}
                            <ListItem disablePadding>
                                <Tooltip title={!drawerOpen ? item.label : ""} placement="right" arrow componentsProps={{ tooltip: { sx: { bgcolor: FB.text, color: "#fff", fontSize: "0.75rem", borderRadius: "8px", px: 1.5, py: 0.75, }, }, }} >
                                    <ListItemButton
                                        onClick={(e) => handleMenuClick(key, hasSub, item.link, item.label, e)}
                                        sx={{
                                            minHeight: 44,
                                            borderRadius: "10px",
                                            px: drawerOpen ? 1.5 : 1.2,
                                            py: 0.75,
                                            justifyContent: drawerOpen ? "initial" : "center",
                                            background: activeParent
                                                ? `linear-gradient(135deg, ${alpha(FB.primary, 0.14)} 0%, ${alpha(FB.primary, 0.07)} 100%)`
                                                : "transparent",
                                            color: activeParent ? FB.primary : FB.textSub,
                                            position: "relative",
                                            overflow: "hidden",
                                            transform: activeParent ? "translateX(2px)" : "translateX(0)",
                                            transition: `background 0.3s ${EASE}, color 0.3s ${EASE}, transform 0.3s ${EASE}`,
                                            "&:hover": {
                                                background: activeParent
                                                    ? `linear-gradient(135deg, ${alpha(FB.primary, 0.2)} 0%, ${alpha(FB.primary, 0.1)} 100%)`
                                                    : FB.hover,
                                                color: activeParent ? FB.primary : FB.text,
                                            },
                                            "& .menu-icon": {
                                                transition: `transform 0.3s ${EASE}, color 0.25s ease`,
                                                transform: activeParent ? "scale(1.12)" : "scale(1)",
                                            },
                                        }}
                                    >
                                        <ActiveBar active={activeParent} />

                                        {/* Icon */}
                                        <ListItemIcon className="menu-icon" sx={{ minWidth: 0, mr: drawerOpen ? 1.75 : "auto", justifyContent: "center", color: "inherit", "& svg": { fontSize: "1.2rem" }, }} >
                                            {item.icon}
                                        </ListItemIcon>

                                        {/* Label */}
                                        {drawerOpen && (
                                            <ListItemText primary={item.label} primaryTypographyProps={{ fontSize: "0.775rem", fontWeight: activeParent ? 700 : 500, color: "inherit", noWrap: true, fontFamily: "'Segoe UI', system-ui, sans-serif", sx: { transition: "font-weight 0.15s ease" }, }} />
                                        )}

                                        {/* Chevron — rotates when open */}
                                        {hasSub && drawerOpen && (
                                            <Box sx={{ ml: "auto", color: "inherit", display: "flex", transition: `transform 0.3s ${EASE}`, transform: isExpanded ? "rotate(0deg)" : "rotate(-90deg)", }} >
                                                <ExpandMoreIcon sx={{ fontSize: "1.1rem" }} />
                                            </Box>
                                        )}
                                    </ListItemButton>
                                </Tooltip>
                            </ListItem>

                            {/* Sub items */}
                            {hasSub && (drawerOpen || isMobile) && (
                                <Collapse in={isExpanded} timeout={260} unmountOnExit>
                                    <Box sx={{ position: "relative" }}>
                                        {/* Vertical connector line */}
                                        {drawerOpen && (
                                            <Box sx={{ position: "absolute", left: 27, top: 6, bottom: 6, width: 1.5, bgcolor: alpha(FB.primary, 0.18), borderRadius: 4, pointerEvents: "none", }} />
                                        )}

                                        <List component="div" disablePadding sx={{ pt: 0.5, pb: 0.5 }} >
                                            {Object.entries(item.subFields).map(([subKey, sub]) => {
                                                if (!shouldShowSubMenuItem(key, subKey)) return null;
                                                const isActive = location.pathname === sub.link;
                                                const denied = rightsReady && !rightsLoading && sub.moduleKey && canAccess && !canAccess(sub.moduleKey, "view");

                                                return (
                                                    <ListItem key={subKey} disablePadding sx={{ mb: 0.3 }} >
                                                        <ListItemButton
                                                            component={denied ? "div" : NavLink}
                                                            to={denied ? undefined : sub.link}
                                                            onClick={() => {
                                                                if (denied) { showAccessDenied?.(); return; }
                                                                saveRecent({ label: sub.label, link: sub.link });
                                                                if (isMobile && closeMobileMenu) closeMobileMenu();
                                                            }}
                                                            sx={{
                                                                minHeight: 38, borderRadius: "8px", px: drawerOpen ? 2 : 1.5, py: 0.5, ml: drawerOpen ? 3.5 : 1.5,
                                                                background: isActive
                                                                    ? `linear-gradient(135deg, ${alpha(FB.primary, 0.14)} 0%, ${alpha(FB.primary, 0.07)} 100%)`
                                                                    : "transparent",
                                                                color: isActive ? FB.primary : FB.textSub,
                                                                position: "relative",
                                                                transform: isActive ? "translateX(2px)" : "translateX(0)",
                                                                transition: `background 0.28s ${EASE}, color 0.25s ease, transform 0.28s ${EASE}`,
                                                                opacity: denied ? 0.45 : 1,
                                                                cursor: denied ? "not-allowed" : "pointer",
                                                                "&:hover": {
                                                                    background: isActive
                                                                        ? `linear-gradient(135deg, ${alpha(FB.primary, 0.2)} 0%, ${alpha(FB.primary, 0.1)} 100%)`
                                                                        : FB.hover,
                                                                    color: isActive ? FB.primary : FB.text,
                                                                },
                                                                "& .submenu-icon": {
                                                                    transition: `transform 0.28s ${EASE}`,
                                                                    transform: isActive ? "scale(1.1)" : "scale(1)",
                                                                },
                                                            }}
                                                        >
                                                            <ActiveDot active={isActive && !denied} />

                                                            <ListItemIcon className="submenu-icon" sx={{ minWidth: 0, mr: 1.75, color: "inherit", "& svg": { fontSize: "1.05rem" } }} >
                                                                {sub.icon}
                                                            </ListItemIcon>

                                                            {(drawerOpen || isMobile) && (
                                                                <ListItemText primary={sub.label} primaryTypographyProps={{ fontSize: "0.725rem", fontWeight: isActive && !denied ? 700 : 500, color: "inherit", fontFamily: "'Segoe UI', system-ui, sans-serif" }} />
                                                            )}

                                                            {denied && drawerOpen && (
                                                                <LockIcon sx={{ fontSize: "0.85rem", ml: "auto", opacity: 0.6 }} />
                                                            )}
                                                        </ListItemButton>
                                                    </ListItem>
                                                );
                                            })}
                                        </List>
                                    </Box>
                                </Collapse>
                            )}
                        </Box>
                    );
                })}
            </List>

            {/* ── Support footer ────────────────────────────────────────────────── */}
            {/* <Box sx={{ px: 1.5, pb: 2.5, borderTop: `1px solid ${FB.divider}` }}> */}
            <Box sx={{ pb: 2.5 }}>
                <Divider sx={{ my: 1.5, borderColor: FB.divider }} />

                {drawerOpen && (
                    <Typography sx={{ fontSize: "0.67rem", fontWeight: 700, color: FB.textSub, letterSpacing: "0.09em", textTransform: "uppercase", mb: 1.25, px: 0.5, }} >
                        Support
                    </Typography>
                )}

                {/* Phone */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: drawerOpen ? "flex-start" : "center", 
                        gap: drawerOpen ? 1.25 : 0,
                        mb: 1.25,
                    }}
                >
                    <Tooltip title={!drawerOpen ? "8866015003 / 004 / 005" : ""} placement="right" arrow >
                        <PhoneIcon sx={{ fontSize: "1rem", color: FB.primary, mt: drawerOpen ? 0.3 : 0, flexShrink: 0, }} />
                    </Tooltip>
                    {drawerOpen && (
                        <Box>
                            <ContactRow href="tel:8866015003" text="8866015003" isNativeApp={isNativeApp} />
                            <ContactRow href="tel:8866015004" text="8866015004" isNativeApp={isNativeApp} />
                            <ContactRow href="tel:8866015005" text="8866015005" isNativeApp={isNativeApp} />
                        </Box>
                    )}
                </Box>

                {/* Email */}
                {drawerOpen && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
                        <EmailIcon sx={{ fontSize: "1rem", color: FB.primary, flexShrink: 0 }} />
                        <Typography component="a" href="mailto:connect.reonbook@gmail.com" sx={{ fontSize: "0.74rem", color: FB.textSub, fontWeight: 500, textDecoration: "none", "&:hover": { color: FB.primary, textDecoration: "underline" }, transition: "color 0.15s ease", }} >
                            support.reonbook@gmail.com
                        </Typography>
                    </Box>
                )}

                {/* Version */}
                <Divider sx={{ mt: 1.75, mb: 1, borderColor: FB.divider }} />
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: drawerOpen ? "flex-start" : "center",
                        gap: 0.75,
                        px: drawerOpen ? 0.5 : 0,
                    }}
                >
                    <Tooltip title={!drawerOpen ? `System Online · ${appVersion}` : ""} placement="right" arrow>
                        <Box
                            sx={{
                                width: 6,
                                height: 6,
                                borderRadius: "50%",
                                bgcolor: "#22c55e",
                                boxShadow: "0 0 0 2px rgba(34,197,94,0.18)",
                                flexShrink: 0,
                            }}
                        />
                    </Tooltip>
                    {drawerOpen && (
                        <Box sx={{ minWidth: 0 }}>
                            <Typography sx={{ fontSize: "0.68rem", fontWeight: 600, color: FB.text, lineHeight: 1.3 }} noWrap>
                                System Online
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: "'Consolas', 'Courier New', monospace",
                                    fontSize: "0.64rem",
                                    color: FB.textSub,
                                    letterSpacing: "0.03em",
                                    lineHeight: 1.3,
                                }}
                                noWrap
                            >
                                {appVersion}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default Menu;